import { createAction } from 'redux-actions';

export const fetchKeywordEvents = createAction('app/FETCH_KEYWORD_EVENTS');
export const updateKeywordEvents = createAction('app/UPDATE_KEYWORD_EVENTS');

export const resetKeywordEventDraft = createAction(
  'app/RESET_KEYWORD_EVENT_DRAFT'
);
export const updateKeywordEventDraft = createAction(
  'app/UPDATE_KEYWORD_EVENT_DRAFT'
);
